import {
  Box,
  Button,
  Modal,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 3,
};

const LoyaltySettingsModal = ({ open, onClose }) => {
  const [defaultValue, setDefaultValue] = useState(0);
  const [increaseByOrder, setIncreaseByOrder] = useState(false);
  const [settingId, setSettingId] = useState("");

  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));
  const restaurantId = Restauranttoken.id;

  // 🔹 GET existing loyalty setting
  useEffect(() => {
    if (!open) return;

    const fetchLoyaltySetting = async () => {
      try {
        const res = await axios.get(
          `${apiAddress}/api/SubSection/GetRestaurantLoyaltySetting/${restaurantId}`
        );

        if (res.data && res.data.length > 0) {
          const data = res.data[0];

          setSettingId(data.id);
          setDefaultValue(data.defaultValue);
          setIncreaseByOrder(data.increaseCountByEachOrder);
        } else {
          // no data → reset
          setSettingId("");
          setDefaultValue(0);
          setIncreaseByOrder(false);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchLoyaltySetting();
  }, [open, apiAddress, restaurantId]);

  // 🔹 SAVE (Insert / Update)
  const handleSave = async () => {
    try {
      await axios.post(
        `${apiAddress}/api/SubSection/AddRestaurantLoyaltySetting`,
        {
          id: settingId, // empty হলে insert, থাকলে update
          restaurantId: restaurantId,
          defaultValue: defaultValue,
          increaseCountByEachOrder: increaseByOrder,
          createdBy: "defaultUser",
        }
      );

      toast.success("Loyalty settings saved successfully!");
      onClose();
    } catch (error) {
      toast.error("Failed to save loyalty settings!");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Loyalty Settings
        </Typography>

        <TextField
          fullWidth
          type="number"
          label="Default Loyalty Points"
          value={defaultValue}
          onChange={(e) => setDefaultValue(Number(e.target.value))}
          margin="normal"
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={increaseByOrder}
              onChange={(e) => setIncreaseByOrder(e.target.checked)}
            />
          }
          label="Increase points on each order"
        />

        <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default LoyaltySettingsModal;
